import { Component, Input, OnInit, OnDestroy, Output, EventEmitter, OnChanges, SimpleChanges } from "@angular/core";
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { Message } from 'shared-components';

@Component({
    selector: 'app-envases-porcion-component',
    templateUrl: './envases-porcion.component.html'
})
export class EnvasesPorcionComponent implements OnInit, OnChanges, OnDestroy {

    public envasesForm: UntypedFormGroup;
    public showError = false;
    public mensajes = new Array<Message>();
    public _editable: boolean;

    public disabledEnvases: Subject<boolean> = new Subject();

    private readonly destroy$ = new Subject<void>();

    get editable(): boolean { return this._editable; }
    @Input() set editable(value: boolean) {
        this._editable = value;
        if (this.envasesForm) {
            if (value) {
                this.envasesForm.enable();
                this.envasesForm.get('id').patchValue(this.idTabla);
            } else {
                this.envasesForm.disable();
                this.disabledEnvases.next(true);
                this.envasesForm.patchValue({
                    id: this.envase.idTabla,
                    envase: this.envase,
                    peso: this.envase.peso,
                    cantidad: this.envase.cantidad
                });
            }
        }
    }

    @Input() idTabla;
    @Input() allEnvases;
    @Input() envase?;

    @Output() refreshAdd = new EventEmitter<any>();
    @Output() refreshRemove = new EventEmitter<any>();
    @Output() close = new EventEmitter<boolean>();

    constructor(private _fb: UntypedFormBuilder) { }

    ngOnInit() {
        if (this.envase) {
            this.envasesForm.disable();
            this.disabledEnvases.next(true);

            this.envasesForm.patchValue({
                id: this.envase.idTabla,
                envase: this.envase,
                peso: this.envase.peso,
                cantidad: this.envase.cantidad
            });
        } else {
            this.envasesForm.get('id').patchValue(this.idTabla);
        }

        this.envasesForm.get('envase').valueChanges.pipe(takeUntil(this.destroy$)).subscribe((envase) => {
            if (envase) {
                this.envasesForm.patchValue({
                    peso: this.envasesForm.get('envase').value.kilos,
                });
            } else {
                this.envasesForm.patchValue({
                    peso: '',
                });
            }
        });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    ngOnChanges(): void {
        if (!this.envasesForm) {
            this.envasesForm = this._fb.group({
                id: [{ value: '', disabled: true }, Validators.required],
                envase: [{ value: '', disabled: !this.editable }, Validators.required],
                peso: [{ value: '', disabled: true }, Validators.required],
                cantidad: [{ value: 1, disabled: !this.editable }, [Validators.required, Validators.max(50)]],
            });
        }

        if (this.envase) {
            this.envasesForm.patchValue({
                id: this.envase.idTabla,
            });
        }
    }

    public save() {
        this.checkForm();
        if (this.envasesForm.valid) {
            const _envase = {
                idTabla: this.envasesForm.get('id').value,
                id: this.envasesForm.get('envase').value.id,
                des: this.envasesForm.get('envase').value.des,
                peso: this.envasesForm.get('peso').value,
                cantidad: this.envasesForm.get('cantidad').value
            };
            this.refreshAdd.emit(_envase);
            this.envasesForm.disable();
            this.disabledEnvases.next(true);
        }
    }

    public remove() {
        this.refreshRemove.emit(this.envase);
    }

    public cancel() {
        if (!this.envase) {
            this.close.emit(false);
        }
    }

    private checkForm() {
        this.showError = this.envasesForm.invalid;
        if (this.envasesForm.invalid && this.envasesForm.get('cantidad').invalid) {
            this.mensajes.push({ class: 'error', message: 'mantenimientoConfecciones.confeccion.envasesConfeccion.limiteCantidad' });
        }
    }
}
